import { render, staticRenderFns } from "./tableFooter.vue?vue&type=template&id=664d7991"
import script from "./tableFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./tableFooter.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports